import React from 'react'
import { useOutletContext } from 'react-router-dom'
import SyncCustomer from './SyncCustomer'

function NetSuite() {
  const { partner, listing } = useOutletContext()

  return (
    <SyncCustomer partner={partner} listing={listing} />
  )
}

export default NetSuite
